var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYouTube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FF0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6985 13.1304C33.369 11.9065 32.4039 10.9415 31.18 10.612C28.944 10 19.9999 10 19.9999 10C19.9999 10 11.0559 10 8.81985 10.5884C7.61947 10.9179 6.63091 11.9065 6.30139 13.1304C5.71297 15.3664 5.71297 20.0032 5.71297 20.0032C5.71297 20.0032 5.71297 24.6636 6.30139 26.876C6.63091 28.1 7.59593 29.065 8.81985 29.3945C11.0794 30.0065 19.9999 30.0065 19.9999 30.0065C19.9999 30.0065 28.944 30.0065 31.18 29.418C32.4039 29.0885 33.369 28.1235 33.6985 26.8996C34.2869 24.6636 34.2869 20.0268 34.2869 20.0268C34.2869 20.0268 34.3104 15.3664 33.6985 13.1304Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.152 24.287L24.5897 20.0032L17.152 15.7195V24.287Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/YouTube.1d2ce1eefb29b381e71d2c67d66598cf.svg";
export { ForwardRef as ReactComponent };